import React, { useState, useEffect } from 'react';
import { MessageSquare, Plus, Trash2, Clock, Search } from 'lucide-react';
import './ConversationHistory.css';

const ConversationHistory = ({ 
  conversations = [], 
  currentConversationId,
  onSelectConversation,
  onCreateConversation,
  onDeleteConversation,
  onNewChat,
  loading = false
}) => {
  console.log('ConversationHistory render:', { 
    conversationsCount: conversations.length, 
    conversations, 
    currentConversationId 
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredConversations, setFilteredConversations] = useState(conversations);

  useEffect(() => {
    const filtered = conversations
      .filter(conv =>
        conv.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    setFilteredConversations(filtered);
  }, [conversations, searchTerm]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 1) return 'Today';
    if (diffDays === 2) return 'Yesterday';
    if (diffDays <= 7) return `${diffDays - 1} days ago`;
    return date.toLocaleDateString();
  };

  const handleDelete = (e, conversationId) => {
    e.stopPropagation();
    if (window.confirm('Are you sure you want to delete this conversation?')) {
      onDeleteConversation(conversationId);
    }
  };

  return (
    <div className="conversation-history">
      <div className="conversation-header">
        <h3>Conversations</h3>
        <button 
          className="new-conversation-btn"
          onClick={onNewChat}
          title="Start new conversation"
        >
          <Plus size={16} />
          New Chat
        </button>
      </div>

      <div className="conversation-search">
        <div className="search-input-container">
          <Search size={16} className="search-icon" />
          <input
            type="text"
            placeholder="Search conversations..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
      </div>

      <div className="conversation-list">
        {loading ? (
          <div className="no-conversations">
            <MessageSquare size={32} className="empty-icon" />
            <p>Loading conversations...</p>
          </div>
        ) : filteredConversations.length === 0 ? (
          <div className="no-conversations">
            <MessageSquare size={32} className="empty-icon" />
            <p>No conversations yet</p>
            <p className="empty-subtitle">Start a new chat to begin analyzing your financial data</p>
          </div>
        ) : (
          filteredConversations.map((conversation) => (
            <div
              key={conversation.id}
              className={`conversation-item ${conversation.id === currentConversationId ? 'active' : ''}`}
              onClick={(e) => {
                console.log('Conversation clicked:', conversation.id, conversation.title);
                console.log('Click event:', e);
                e.preventDefault();
                e.stopPropagation();
                onSelectConversation(conversation.id);
              }}
              onMouseDown={(e) => {
                console.log('Conversation mousedown:', conversation.id);
              }}
              style={{ pointerEvents: 'auto', cursor: 'pointer' }}
            >
              <div className="conversation-content">
                <div className="conversation-title">
                  <MessageSquare size={16} />
                  <span>{conversation.title}</span>
                </div>
                <div className="conversation-meta">
                  <Clock size={12} />
                  <span>{formatDate(conversation.created_at)}</span>
                </div>
              </div>
              <button
                className="delete-conversation-btn"
                onClick={(e) => handleDelete(e, conversation.id)}
                title="Delete conversation"
              >
                <Trash2 size={14} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ConversationHistory; 